module.exports = __webpack_public_path__ + "media/question3_en.2aa61d52.mp3";